import { render, staticRenderFns } from "./ReceiptInvoicePDF.vue?vue&type=template&id=18be8b4c&scoped=true&"
import script from "./ReceiptInvoicePDF.vue?vue&type=script&lang=js&"
export * from "./ReceiptInvoicePDF.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptInvoicePDF.vue?vue&type=style&index=0&id=18be8b4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18be8b4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VContainer,VIcon,VOverlay,VProgressCircular})
